import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePageLayout } from '@app/router';
import PostcardCreateModal from '../components/PostcardCreateModal';
import { ROUTES } from '@app/router/routes';

export default function PostcardCreatePage() {
  const navigate = useNavigate();
  const { setLayoutOptions } = usePageLayout();

  useEffect(() => {
    setLayoutOptions({ hideHeader: true, hideBottomNav: true, hideFooter: true, noPaddingTop: true, noPaddingBottom: true });
    return () => setLayoutOptions({});
  }, [setLayoutOptions]);

  return (
    <PostcardCreateModal
      isOpen={true}
      onClose={() => navigate(ROUTES.HOME)}
    />
  );
}
